export const containerQueries = {
  isWideContainer: {
    minWidth: 1470,
  },
}
